<template>
  <mail-templates-editor v-model="mail_template"></mail-templates-editor>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';

export default {
  props: ['mail_template_id'],
  data: function () {
    return {
      mail_template: null
    };
  },
  methods: {},
  async mounted() {
    Api.find('mail_templates', this.mail_template_id).then(({ data }) => {
      this.mail_template = data;
      let breadcrumbs = [
        { to: { name: 'settings_index' }, text: this.$t('settings') },
        {
          to: { name: 'mail_templates' },
          text: this.$t('routes_mail_templates')
        },
        {
          to: {
            name: 'mail_template_edit',
            mail_template_id: this.mail_template_id
          },
          text: this.mail_template.name
        }
      ];
      this.setBreadcrumbs(breadcrumbs);
    });
  }
};
</script>

<style scoped></style>
